import { useSelector } from 'react-redux'

import { selectDocumentDelegateName, selectFeature, selectFileDeliveryOptions, selectIntegrations, selectScid } from '.'

export const useScid = () => {
  const scid = useSelector(selectScid)
  if (!scid) throw new Error('No scid found')
  return scid
}

export const useDocumentDelegateName = (): string => useSelector(selectDocumentDelegateName)
export const useApplicationIntegrationEnabled = (): boolean => useSelector(selectFeature('ApplicationIntegration'))
export const useIntegrationsAndDeliveryOptions = () => {
  const integrations = useSelector(selectIntegrations)
  const fileDeliveryOptions = useSelector(selectFileDeliveryOptions)
  return {
    integrations,
    fileDeliveryOptions,
  }
}
export const useSupportsStudentOutreach = (): boolean => useSelector(selectFeature('SupportsStudentOutreach'))
export const useSupportsLimitedAutomatedOutreach = (): boolean =>
  useSelector(selectFeature('SupportsLimitedAutomatedStudentOutreach'))
